import { func } from 'prop-types'

import noop from 'shared/utils/noop'
import OffCanvasItemList from 'views/components/organisms/OffCanvas/OffCanvasItemList'
import { offCanvasCategory } from 'views/utils/propTypes'

const OffCanvasBottomLinks = ({ data, goNextHandler }) => (
  <div className="u-margin-auto--top">
    {data && <OffCanvasItemList data={data} goNextHandler={goNextHandler} />}
    <ul className="a-list-reset" />
  </div>
)

OffCanvasBottomLinks.propTypes = {
  data: offCanvasCategory,
  goNextHandler: func,
}

OffCanvasBottomLinks.defaultProps = {
  data: null,
  goNextHandler: () => noop,
}

export default OffCanvasBottomLinks
